import { FadeIn } from "../components/FadeIn";
import { IMAGES, BOOKING_URL, GURUGRAM_PHOTOS } from "../data/content";
import { ShieldCheck, Heart, Crown, Award, MapPin, Camera } from "lucide-react";

export const AboutPage = () => {
  return (
    <div className="py-12 sm:py-20 px-4 sm:px-8 lg:px-12">
      {/* Banner */}
      <div className="max-w-7xl mx-auto text-center mb-16">
        <FadeIn>
          <div className="text-xs uppercase tracking-[0.25em] text-emerald-400 font-extrabold mb-3">
            Heritage & Sanctuary
          </div>
          <h1 className="text-4xl sm:text-6xl font-serif font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-yellow-400 to-emerald-400 mb-6">
            About G69 Men Spa Gurugram
          </h1>
          <p className="text-white/70 max-w-2xl mx-auto text-sm sm:text-base leading-relaxed">
            Six centuries of eastern bathing heritage and contemporary wellness craft, reimagined for today's gentleman in Gurgaon.
          </p>
        </FadeIn>
      </div>

      {/* Main Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
        <FadeIn>
          <div className="relative rounded-3xl overflow-hidden border border-amber-400/40 shadow-2xl shadow-yellow-950/20">
            <img
              src={IMAGES.about}
              alt="About G69 Spa"
              className="w-full h-[400px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <span className="text-xs font-bold uppercase tracking-widest text-amber-400 bg-black/80 px-4 py-2 rounded-full border border-amber-400/40">
                Sikanderpur • DLF Phase 1, Gurgaon
              </span>
            </div>
          </div>
        </FadeIn>

        <FadeIn>
          <div className="space-y-6">
            <div className="text-xs uppercase tracking-[0.2em] text-amber-400 font-bold">
              Our Vision & Philosophy
            </div>
            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-white">
              A Safe, Inclusive & Premium Male Sanctuary
            </h2>
            <p className="text-sm sm:text-base text-white/80 leading-relaxed">
              G69 Men Spa was established with a singular mission: to provide a truly judgment-free, safe, and opulent space where men from all walks of life can unwind, heal, and rejuvenate.
            </p>
            <p className="text-sm text-white/70 leading-relaxed">
              We don't believe in quick fixes. We believe in heat, time, aromatic oils, clean water, and pure human touch. Located near Sikanderpur Metro Station in DLF Phase 1, our sanctuary offers total privacy, soundproof therapy rooms, and complete peace of mind.
            </p>

            <div className="pt-4 grid grid-cols-2 gap-4">
              <div className="border border-white/10 p-4 rounded-2xl bg-[#0c0c0c]">
                <ShieldCheck className="w-6 h-6 text-emerald-400 mb-2" />
                <h4 className="text-xs font-bold text-white uppercase tracking-wider">100% Privacy</h4>
                <p className="text-[11px] text-white/50 mt-1">Discreet soundproof private suites</p>
              </div>
              <div className="border border-white/10 p-4 rounded-2xl bg-[#0c0c0c]">
                <Heart className="w-6 h-6 text-rose-400 mb-2" />
                <h4 className="text-xs font-bold text-white uppercase tracking-wider">Gay Friendly</h4>
                <p className="text-[11px] text-white/50 mt-1">Inclusive & respectful environment</p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>

      {/* Gurugram Branch Photo Gallery */}
      <div className="max-w-7xl mx-auto mb-20 pt-12 border-t border-white/10">
        <FadeIn className="text-center mb-10">
          <div className="text-xs uppercase tracking-[0.25em] text-amber-400 font-extrabold mb-2 flex items-center justify-center gap-2">
            <Camera className="w-4 h-4" /> Real Branch Ambiance
          </div>
          <h2 className="text-3xl font-serif font-bold text-white">
            Gurugram Branch Photo Gallery
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {GURUGRAM_PHOTOS.map((photo, pIdx) => (
            <FadeIn key={pIdx} delay={pIdx * 0.1}>
              <div className="h-64 rounded-2xl overflow-hidden border border-amber-400/30 group shadow-lg">
                <img
                  src={photo}
                  alt={`Gurugram Branch ${pIdx + 1}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
            </FadeIn>
          ))}
        </div>
      </div>

      {/* CTA Box */}
      <div className="max-w-4xl mx-auto text-center pt-12 border-t border-white/10">
        <FadeIn>
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-amber-300 via-yellow-500 to-amber-600 text-black font-extrabold px-10 py-4 rounded-full text-xs uppercase tracking-[0.2em] shadow-lg hover:scale-105 transition-transform"
          >
            Book Your Session Today
          </a>
        </FadeIn>
      </div>
    </div>
  );
};
